import FuzzySearch from 'fuzzy-search';
import {useMemo} from 'react';
import accents from 'remove-accents';
import {AttributeFilterItem} from './AttributeItems';

export const useFilteredAttributeItems = ({
  attributeItems,
  search,
  shouldFilter,
}: {
  attributeItems: Array<AttributeFilterItem>;
  search: string;
  shouldFilter: boolean;
}) => {
  return useMemo(() => {
    if (!shouldFilter || search === '') return attributeItems;
    if (!attributeItems?.length) return [];

    const resultItems = attributeItems.filter(attributeItem => {
      const {label} = attributeItem;

      const attributeLabel = label.toLocaleLowerCase();
      const attributeLabelWithoutAccents = accents.remove(attributeLabel);

      const searcher = new FuzzySearch(
        [attributeLabel, attributeLabelWithoutAccents],
        [],
        {
          caseSensitive: false,
          sort: true,
        },
      );
      const foundResultInFuzzySearch =
        searcher.search(search.toLowerCase()).length > 0;

      return foundResultInFuzzySearch;
    });
    return resultItems;
  }, [attributeItems, search, shouldFilter]);
};
